import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';
import { prepareSearchParams } from '@/libs/helper';

const resource = `${Config.basePath}/department`;

export default {
  list(payload) {
    return Client.get(resource, {
      params: prepareSearchParams(payload)
    });
  },
  create(payload) {
    return Client.post(`${resource}/create`, payload);
  },

  update(id, payload) {
    return Client.put(`${resource}/update/${id}`, payload);
  },
  destroy(id) {
    return Client.delete(`${resource}/delete/${id}`);
  },
  show(id) {
    return Client.get(`${resource}/find-one/${id}`);
  },
  options(payload) {
    payload.order = 'name';
    payload.sort = 'asc';
    return Client.get(`${resource}/find/option`, {
      params: payload
    });
  }
};
